export const loadBrandData = async brand => {
    
    const brandHash = (brand: string) => {
    if (!brand) {
      return '';
    }
  
    const code = Array.from(brand)
      .map((c) => c.charCodeAt(0))
      .join('');

    return "brand-" + code;
  };

    const brandMap = {
      "brand-1171001159510010110297117108116": async () => await import(/* webpackChunkName: "brand-1171001159510010110297117108116" */ "./uds_default"),"brand-9798114105116101108": async () => await import(/* webpackChunkName: "brand-9798114105116101108" */ "./abritel"),"brand-9811111110797989799104": async () => await import(/* webpackChunkName: "brand-9811111110797989799104" */ "./bookabach"),"brand-10112011210110010597": async () => await import(/* webpackChunkName: "brand-10112011210110010597" */ "./expedia"),"brand-102101119111100105114101107116": async () => await import(/* webpackChunkName: "brand-102101119111100105114101107116" */ "./fewodirekt"),"brand-104111116101108115": async () => await import(/* webpackChunkName: "brand-104111116101108115" */ "./hotels"),"brand-11511697121122": async () => await import(/* webpackChunkName: "brand-11511697121122" */ "./stayz"),"brand-11811498111": async () => await import(/* webpackChunkName: "brand-11811498111" */ "./vrbo"),"brand-119111116105102": async () => await import(/* webpackChunkName: "brand-119111116105102" */ "./wotif")
    };
    const brandIndex = brandHash(brand);

    if (brandIndex in brandMap) {
      return await brandMap[brandIndex]();
    } else {
      return await brandMap['brand-1171001159510010110297117108116']();
    }
  };
  